module.exports = __webpack_public_path__ + "static/och-logo-26002adfa067ea34b2fe1c64f2f816f3.png";